function getCode(code) {

	let parentCode = [];

	for (const i in code.parentProps) {

		if (i === 'display' && code.parentProps[i] !== '') {
			parentCode[0] = {
				display: `<span class='parent-prop'>&nbsp;&nbsp;&nbsp;&nbsp;display : </span> <span> ${code.parentProps[i]};</span>`
			}
		} else if (i === 'flexDirection' && code.parentProps[i] !== '') {
			parentCode[1] = {
				flexDirection: `<span class='parent-prop'>&nbsp;&nbsp;&nbsp;&nbsp;flex-direction : </span> <span> ${code.parentProps[i]};</span>`
			}
		} else if (i === 'flexWrap' && code.parentProps[i] !== '') {
			parentCode[2] = {
				flexWrap: `<span class='parent-prop'>&nbsp;&nbsp;&nbsp;&nbsp;flex-wrap : </span> <span> ${code.parentProps[i]};</span>`
			}
		} else if (i === 'justifyContent' && code.parentProps[i] !== '') {
			parentCode[3] = {
				justifyContent: `<span class='parent-prop'>&nbsp;&nbsp;&nbsp;&nbsp;justify-content : </span> <span> ${code.parentProps[i]};</span>`
			}
		} else if (i === 'alignItems' && code.parentProps[i] !== '') {
			parentCode[4] = {
				alignItems: `<span class='parent-prop'>&nbsp;&nbsp;&nbsp;&nbsp;align-items : </span> <span> ${code.parentProps[i]};</span>`
			}
		} else if (i === 'alignContent' && code.parentProps[i] !== '') {
			parentCode[5] = {
				alignContent: `<span class='parent-prop'>&nbsp;&nbsp;&nbsp;&nbsp;align-content : </span> <span> ${code.parentProps[i]};</span>`
			}
		}
	}


	let flexItemCode = [];

	code.flexItemProps.map((i, j) => {

		let foo1 = [];

		for (const q in i) {

			if (q === 'order' && i[q] !== '') {
				foo1[0] = {
					order: `<span class="parent-prop">&nbsp;&nbsp;&nbsp;&nbsp;order : </span> <span>${i[q]};</span>`
				}
			} else if (q === 'flexGrow' && i[q] !== '') {
				foo1[1] = {
					flexGrow: `<span class="parent-prop">&nbsp;&nbsp;&nbsp;&nbsp;flex-grow : </span> <span>${i[q]};</span>`
				}
			} else if (q === 'flexShrink' && i[q] !== '') {
				foo1[2] = {
					flexShrink: `<span class="parent-prop">&nbsp;&nbsp;&nbsp;&nbsp;flex-shrink : </span> <span>${i[q]};</span>`
				}
			} else if (q === 'flexBasis' && i[q] !== '') {
				foo1[3] = {
					flexBasis: `<span class="parent-prop">&nbsp;&nbsp;&nbsp;&nbsp;flex-basis : </span> <span>${i[q]};</span>`
				}
			} else if (q === 'alignSelf' && i[q] !== '') {
				foo1[4] = {
					alignSelf: `<span class="parent-prop">&nbsp;&nbsp;&nbsp;&nbsp;align-self : </span> <span>${i[q]};</span>`
				}
			}
		}

		flexItemCode.push(foo1);

		return null;

	})


	function parseSnippet(parentProps, itemProps) {

		let someVal = [];

		parentProps.map(i => {

			for (const jj in i) {
				someVal.push(i[jj])
			}

			return null;

		})

		// --------------------------------- Parent Prop End ------------------------

		// --------------------------------- Item Prop Start ------------------------


		let someVal3 = [];


		itemProps.map(i => {

			let someVal2 = [];


			i.map(j => {

				for (const kk in j) {
					someVal2.push(j[kk])
				}

				return null;
			})

			someVal3.push(someVal2);

			return null;


		});

		let itemPropsStringArr = someVal3.map((i, j) => {

			if(i.length === 0){
				return null;
			}

			return `<span class='cssClassStyle'>.flex-item-${j+1} &#123; <br/>
			${i}
			<br/>&#125;<br/>`
		})


		// --------------------------------- Item Prop End --------------------------




		return (
			`<span class='cssClassStyle'>.flex-container &#123; <br/>
			${someVal}
			<br/>&#125;</span>
			<br/><br/>

			${itemPropsStringArr}<br/>

			`)

	}

	return parseSnippet(parentCode, flexItemCode);

}


export default getCode;